import { bubEvents } from 'shared/events/bub_events';
import { SiteConversionTrackingHelper } from 'shared/events/site_conversion_tracking_helper';
import { stringFormatUtils } from 'javascripts/shared/utils/string_format_utils';

$(document).ready(() => {
  $('.announcement-wrapper .sign-up-link').on('click touch', event => {
    bubEvents.track('Header', 'Clicked link', { label: 'Sign up' });

    const signupTracker = new SiteConversionTrackingHelper('Header sign up link', event, { label: 'Sign Up' });
    signupTracker.trackConversion();
  });

  // Announcement banner
  $('.announcement-wrapper .sign-in-link').on('click touch', () => {
    bubEvents.track('Header', 'Clicked link', { label: 'Sign in' });
  });

  $('.announcement-wrapper .how-to-listen-link').on('click touch', () => {
    bubEvents.track('Announcement banner', 'Clicked link', { label: 'How to listen' });
  });

  $('.announcement-wrapper .custom-banner-link').on('click touch', e => {
    bubEvents.track('Announcement banner', 'Clicked link', { label: stringFormatUtils.stripEmojis(e.target.innerText) });
  });

  // User account name/icon
  $('.header-content .account-menu-icon').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', { label: 'Account icon' });
  });

  // Account dropdown section
  $('.header-content .header-logo').on('click touch', () => {
    bubEvents.track('Header', 'Clicked link', { label: 'Chirp logo' });
  });

  $('.header-content .header-action a').on('click touch', e => {
    bubEvents.track('Header', 'Clicked link', { label: e.target.innerText });
  });

  $('.header-account .account-sign-in-link').on('click touch', () => {
    bubEvents.track('Header', 'Clicked link', { label: 'Sign in' });
  });

  // Horizontal categories links
  $('.common-links-content .secondary-links .common-link').on('click touch', e => {
    bubEvents.track('Header', 'Clicked link', { label: e.target.innerText });
  });

  $('.common-links-content .secondary-links .featured-deals-link').on('click touch', () => {
    bubEvents.track('Header', 'Clicked link', { label: 'Featured Deals' });
  });

  // Remember the nav bar scroll position on page reload
  const scrollableNavElement = $('.scrollable-links-inner');
  scrollableNavElement.scrollLeft(window.Cookies.get('navbar_scroll_left'));
  $('.common-links-content .scrollable-links .scrollable-links-inner').on('scroll', () => {
    window.Cookies.set('navbar_scroll_left', scrollableNavElement.scrollLeft());
  });

  // Reset nav scroll position when the home link is clicked
  $('.header-content .logo-link').on('click touch', () => {
    window.Cookies.set('navbar_scroll_left', '0');
  });
});
